// Generated by Melange

import * as Buhta_cabinet__BatchSignForm from "../../../models/BatchSignForm.js";
import * as Buhta_cabinet__BatchSignProgress from "./BatchSignProgress.js";
import * as Buhta_cabinet__ButtonPrimary from "../../../components/html/ButtonPrimary.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__DocumentEdo from "../../../grpc/DocumentEdo.js";
import * as Buhta_cabinet__NcaLayerConnectionErrorModal from "./NcaLayerConnectionErrorModal.js";
import * as Buhta_cabinet__NcaLayerModuleNotInstalledModal from "./NcaLayerModuleNotInstalledModal.js";
import * as Buhta_cabinet__NcaLayerSelectCertModal from "./NcaLayerSelectCertModal.js";
import * as Buhta_cabinet__NcaLayerUpdateModuleModal from "./NcaLayerUpdateModuleModal.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Let_syntax from "../../../../../../packages/core/lib/Let_syntax.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_struct from "../../../../../../proto/third_party/google_wkt/gen/google_protobuf_struct.js";
import * as MelNumeral from "../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BatchSignLayout(Props) {
  let org = Props.org;
  let id = Props.id;
  let batch = Props.batch;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const refSign = React.useRef(null);
  const match$1 = React.useState(function () {
    return false;
  });
  const setShowConnectionErrorModal = match$1[1];
  const match$2 = React.useState(function () {
    return false;
  });
  const setShowSelectCertModal = match$2[1];
  const match$3 = React.useState(function () {
    return "";
  });
  const setProgressMessage = match$3[1];
  const match$4 = React.useState(function () {
    return false;
  });
  const setSelectCertPending = match$4[1];
  const match$5 = React.useState(function () {
    return false;
  });
  const setShowModuleNotInstalledModal = match$5[1];
  const match$6 = React.useState(function () {
    return false;
  });
  const setShowUpdateModuleModal = match$6[1];
  const ws = React.useRef(undefined);
  const match$7 = React.useState(function () {
    return /* Initial */ 0;
  });
  const setStage = match$7[1];
  const stage = match$7[0];
  const onStageTransition = function (stage) {
    if (/* tag */ typeof stage === "number" || typeof stage === "string") {
      stage === /* Processing */ 1;
    } else if (stage.TAG === /* Ncalayer */ 0) {
      let tmp = stage._0;
      if (!/* tag */ (typeof tmp === "number" || typeof tmp === "string")) {
        switch (tmp.TAG) {
          case /* Connected */ 0 :
            Curry._1(setShowSelectCertModal, (function (param) {
              return true;
            }));
            break;
          case /* ConnectionFailed */ 1 :
            Curry._1(setShowConnectionErrorModal, (function (param) {
              return true;
            }));
            break;
        }
      }
      
    } else {
      let tmp$1 = stage._0;
      if (/* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string") {
        if (tmp$1 === /* Initial */ 0) {
          Curry._1(setSelectCertPending, (function (param) {
            return false;
          }));
        } else {
          Curry._1(setSelectCertPending, (function (param) {
            return true;
          }));
        }
      } else if (tmp$1.TAG === /* Failed */ 0) {
        Curry._1(setSelectCertPending, (function (param) {
          return false;
        }));
      } else {
        Curry._1(setShowSelectCertModal, (function (param) {
          return false;
        }));
      }
    }
    Curry._1(setStage, (function (param) {
      return stage;
    }));
  };
  const onFetchNextBulk = function (send, state, param) {
    Curry._1(setProgressMessage, (function (param) {
      return "Загружаем партию документов...";
    }));
    const params_filters = {
      hd: {
        name: "register_num_gt",
        value: Curry._2(Google_wkt__Google_protobuf_struct.Google.Protobuf.Value.make, {
          NAME: "Number_value",
          VAL: state.register_num
        }, undefined)
      },
      tl: /* [] */ 0
    };
    const params = {
      search: undefined,
      page: 0,
      filters: params_filters,
      expand: /* [] */ 0
    };
    return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__DocumentEdo.DocumentSignService.gridBatchSignDocuments(tenant, params, id, undefined), (function (response) {
      if (response.TAG === /* Ok */ 0) {
        return Curry._1(send, {
          TAG: /* SignBulk */ 3,
          _0: response._0
        });
      }
      console.log("fetch err", response._0);
    }));
  };
  const onBulkSubmit = function (send, documents, param) {
    Curry._1(setProgressMessage, (function (param) {
      return "Подписываем документы...";
    }));
    return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__DocumentEdo.DocumentSignService.bulkSign(tenant, documents, undefined), (function (result) {
      if (result.TAG === /* Ok */ 0) {
        Curry._1(send, {
          TAG: /* ProcessBulkResult */ 5,
          _0: result._0
        });
      }
      return result;
    }));
  };
  const onStartOver = function (send, state, param) {
    Curry._1(send, /* Start */ 0);
  };
  const match$8 = Buhta_cabinet__BatchSignForm.useForm(onStageTransition, onStartOver, onFetchNextBulk, onBulkSubmit, (function (param) {
    return {
      batch: batch,
      client: undefined,
      cert: undefined,
      register_num: 0,
      signed: 0,
      sign_failed: /* [] */ 0,
      fetched: 0
    };
  }));
  const updateForm = match$8[1];
  const form = match$8[0];
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Подписание реестра " + batch.code,
    route: contextRoute({
      TAG: /* Documents */ 1,
      _0: {
        TAG: /* Batches */ 6,
        _0: {
          TAG: /* View */ 0,
          _0: id
        }
      }
    }),
    arrowBack: true
  });
  const match$9 = batch.owner_stats;
  const totalCount = match$9 !== undefined ? match$9.sign_required_count - match$9.signed_count | 0 : 0;
  const totalCountLabel = MelNumeral.formatInt({
    NAME: "Int",
    VAL: totalCount
  });
  let tmp;
  let exit = 0;
  if (/* tag */ (typeof stage === "number" || typeof stage === "string") && stage !== /* Initial */ 0) {
    tmp = JsxRuntime.jsx(Buhta_cabinet__BatchSignProgress.make, {
      batch: batch,
      form: form,
      stage: stage,
      completeRoute: contextRoute({
        TAG: /* Documents */ 1,
        _0: {
          TAG: /* Batches */ 6,
          _0: {
            TAG: /* View */ 0,
            _0: id
          }
        }
      }),
      onRestartClicked: (function (param) {
        Curry._1(updateForm, /* Start */ 0);
      }),
      progressMessage: match$3[0]
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/batch.svg")
            }),
            JsxRuntime.jsx("div", {
              className: "h-px bg-gray-main w-8"
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/eds.svg")
            }),
            JsxRuntime.jsx("div", {
              className: "h-px bg-gray-main w-8"
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/signature.svg")
            })
          ],
          className: "flex gap-2 items-center"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            children: "Всего к подписанию: " + totalCountLabel
          }),
          className: "space-y-2 text-center"
        }),
        JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
          title: "Подписать все документы",
          onClick: (function (param) {
            ws.current = Buhta_cabinet__BatchSignForm.initNcalayer(updateForm);
          }),
          reference: refSign
        })
      ],
      className: "py-20 flex flex-col items-center w-full gap-6"
    });
  }
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: [
      tmp,
      match$1[0] ? JsxRuntime.jsx(Buhta_cabinet__NcaLayerConnectionErrorModal.make, {
          onClose: (function (param) {
            Curry._1(setShowConnectionErrorModal, (function (param) {
              return false;
            }));
          })
        }) : null,
      match$2[0] ? JsxRuntime.jsx(Buhta_cabinet__NcaLayerSelectCertModal.make, {
          pending: match$4[0],
          onClose: (function (param) {
            Curry._1(setShowSelectCertModal, (function (param) {
              return false;
            }));
          }),
          onSelectCert: (function (param) {
            const client = form.client;
            if (client !== undefined) {
              Buhta_cabinet__BatchSignForm.selectCert(batch.tin, Caml_option.valFromOption(client), updateForm);
              return;
            }
            
          })
        }) : null,
      match$5[0] ? JsxRuntime.jsx(Buhta_cabinet__NcaLayerModuleNotInstalledModal.make, {
          onClose: (function (param) {
            Curry._1(setShowModuleNotInstalledModal, (function (param) {
              return false;
            }));
          })
        }) : null,
      match$6[0] ? JsxRuntime.jsx(Buhta_cabinet__NcaLayerUpdateModuleModal.make, {
          onClose: (function (param) {
            Curry._1(setShowUpdateModuleModal, (function (param) {
              return false;
            }));
          })
        }) : null
    ]
  });
}

const make = BatchSignLayout;

export {
  make,
}
/* Buhta_cabinet__BatchSignForm Not a pure module */
